module.exports = __webpack_public_path__ + "img/ppc-loan.9a93fef6.png";